import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class ItineraryType extends BaseEntity{
    
    itineraryTypeCode : string;
    name : string;
    rank : number;

}
